import { render, staticRenderFns } from "./TenancyDepositReleaseLeabank.vue?vue&type=template&id=8594d54c&scoped=true&"
import script from "./TenancyDepositReleaseLeabank.vue?vue&type=script&lang=js&"
export * from "./TenancyDepositReleaseLeabank.vue?vue&type=script&lang=js&"
import style0 from "./TenancyDepositReleaseLeabank.vue?vue&type=style&index=0&id=8594d54c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8594d54c",
  null
  
)

export default component.exports